import { render } from "./ChatRDG.vue?vue&type=template&id=5b236a07"
import script from "./ChatRDG.vue?vue&type=script&lang=js"
export * from "./ChatRDG.vue?vue&type=script&lang=js"

import "./ChatRDG.vue?vue&type=style&index=0&id=5b236a07&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__